var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { Input } from '../../forms/Input';
import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
const Styles = labelStyles('TextInput', {
    input: (props) => [
        { minWidth: 1 },
        props.isMultiline &&
            withModifier('multiline', {
                height: 'auto',
            }),
        props.isFullWidth &&
            withModifier('fullwidth', {
                width: '100%',
            }),
        props.resize &&
            withModifier(`resize-${props.resize}`, {
                resize: props.resize,
            }),
    ],
});
export const TextInput = forwardRef((_a, ref) => {
    var { isMultiline = false, type = 'text', isFullWidth = false, size = 'small', borderRadius = 3 } = _a, otherProps = __rest(_a, ["isMultiline", "type", "isFullWidth", "size", "borderRadius"]);
    const props = Object.assign({ isMultiline,
        type,
        isFullWidth,
        size,
        borderRadius }, otherProps);
    const Tag = props.isMultiline ? 'textarea' : 'input';
    return (isolateComponent(Input, Object.assign({}, props, { renderIconAfter: props.isMultiline ? undefined : props.renderIconAfter, renderIconBefore: props.isMultiline ? undefined : props.renderIconBefore }), (inputProps) => (isolateComponent(Tag, Object.assign({}, inputProps, { autoCapitalize: props.autoCapitalize, autoCorrect: props.autoCorrect, css: [inputProps.css, Styles.input(props)], inputMode: props.inputMode, ref: ref, rows: props.isMultiline ? props.rows : undefined, spellCheck: props.spellCheck, type: !props.isMultiline ? props.type : undefined, value: inputProps.value, onChange: inputProps.onChange })))));
});
//# sourceMappingURL=TextInput.js.map
// @zapier/design-system@6.27.0 (617a97f69)
